(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ===== THE SILLAGE STUDIO — collection-grid card behaviour =====
     - tss-wishlist: browser-local favourites (localStorage). NOT account-synced;
       structured so it can later sync to a customer metafield / app.
     - quick add-to-cart via /cart/add.js (the cart FAB's fetch hook bumps the count). */
  (function () {
    if (window.__tssCardBooted) return;
    window.__tssCardBooted = true;

    var WKEY = 'tss_wishlist';

    var tssWishlist = {
      read: function () {
        try {
          var v = JSON.parse(localStorage.getItem(WKEY) || '[]');
          return Array.isArray(v) ? v : [];
        } catch (e) {
          return [];
        }
      },
      write: function (arr) {
        try {
          localStorage.setItem(WKEY, JSON.stringify(arr));
        } catch (e) {}
      },
      has: function (handle) {
        return this.read().indexOf(handle) !== -1;
      },
      toggle: function (handle) {
        var list = this.read();
        var i = list.indexOf(handle);
        if (i === -1) {
          list.push(handle);
        } else {
          list.splice(i, 1);
        }
        this.write(list);
        return i === -1; /* true = now saved */
      }
    };
    /* Expose for a future account-sync swap-in. */
    window.tssWishlist = tssWishlist;

    function cssEscape(s) {
      if (window.CSS && CSS.escape) return CSS.escape(s);
      return String(s).replace(/["\\\]]/g, '\\$&');
    }

    function setFavState(btn, saved) {
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.classList.toggle('is-saved', saved);
      var title = btn.getAttribute('data-title') || 'this item';
      btn.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + title + (saved ? ' from favourites' : ' to favourites'));
    }

    function hydrateFav(btn) {
      setFavState(btn, tssWishlist.has(btn.getAttribute('data-tss-fav')));
    }

    function hydrate(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var btns = scope.querySelectorAll('[data-tss-fav]');
      for (var i = 0; i < btns.length; i++) hydrateFav(btns[i]);
    }

    function flash(btn, msg) {
      var lbl = btn.querySelector('.tss-card__add-label');
      if (!lbl) return;
      var orig = btn.getAttribute('data-label-add');
      lbl.textContent = msg;
      setTimeout(function () {
        lbl.textContent = orig;
      }, 1600);
    }

    document.addEventListener('click', function (e) {
      /* Favourite toggle */
      var fav = e.target.closest('[data-tss-fav]');
      if (fav) {
        e.preventDefault();
        e.stopPropagation();
        var handle = fav.getAttribute('data-tss-fav');
        var nowSaved = tssWishlist.toggle(handle);
        var twins = document.querySelectorAll('[data-tss-fav="' + cssEscape(handle) + '"]');
        for (var i = 0; i < twins.length; i++) setFavState(twins[i], nowSaved);
        return;
      }

      /* Quick add-to-cart */
      var add = e.target.closest('[data-tss-add]');
      if (add) {
        e.preventDefault();
        e.stopPropagation();
        if (add.hasAttribute('disabled') || add.getAttribute('data-busy') === '1') return;
        var vid = add.getAttribute('data-variant-id');
        if (!vid) return;

        add.setAttribute('data-busy', '1');
        add.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        })
          .then(function (r) {
            return r.json().then(function (d) {
              return { ok: r.ok, data: d };
            });
          })
          .then(function (res) {
            add.classList.remove('is-loading');
            add.removeAttribute('data-busy');
            if (!res.ok) {
              flash(add, 'Try again');
              return;
            }
            var lbl = add.querySelector('.tss-card__add-label');
            var orig = add.getAttribute('data-label-add');
            if (lbl) lbl.textContent = add.getAttribute('data-label-added');
            add.classList.add('is-added');
            /* The cart FAB hooks window.fetch and bumps its badge; fire the theme
               event too so any cart listener re-syncs. */
            document.dispatchEvent(new CustomEvent('cart:update'));
            setTimeout(function () {
              if (lbl) lbl.textContent = orig;
              add.classList.remove('is-added');
            }, 1600);
          })
          .catch(function () {
            add.classList.remove('is-loading');
            add.removeAttribute('data-busy');
            flash(add, 'Try again');
          });
        return;
      }
    });

    /* Hydrate hearts on load and for cards added later (infinite scroll / facet morphs). */
    if (document.readyState !== 'loading') {
      hydrate(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        hydrate(document);
      });
    }

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-tss-fav]')) {
            hydrateFav(n);
          } else if (n.querySelector) {
            hydrate(n);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function (e) {
      hydrate(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
